module.exports = __webpack_public_path__ + "img/versus-btn.15e30acc.png";